import React from "react"

import FieldProto from "../../../../../proto/field-proto"
import ModelEntity from "../../../../../../model2/model-entity"
import {stringToTimeOfDay} from "../../../../../../gd/utils/datetime/string-to-time-value"
import {TimeValue} from "../../../../../../gd/types/datetime"
import formatTime from "../../../../../../gd/format/time"

type Props = {
    parent      : any           // this is a view with props...
    field       : FieldProto
    model?      : ModelEntity
    onChange    : callback
    value       : any
}

type State = {
    userInput       : string,
    value           : TimeValue | null
    isValid         : boolean
}

export default class FieldTimeOfDay_PopoverValue extends React.PureComponent<Props, State> {

    public refInput    : React.RefObject<any> = React.createRef<any>()

    constructor(props:Props) {
        super(props)

        // const currentValue : Moment | null | undefined  = props.field.getViewValue(props.model)
        const currentValue : Moment | null | undefined  = props.value

        const userInput: string     = currentValue ? formatTime(currentValue) : ''
        const value = stringToTimeOfDay(userInput)

        this.state = {
            userInput   : userInput,
            value       : null,
            isValid     : !userInput || !!value
        }
    }

    componentDidMount() {
        this.refInput.current.focus();
    }

    onKeyDown = (event:React.KeyboardEvent) => {
        switch(event.key){
            case 'Enter':
                if (this.props.onChange) this.props.onChange(this.state.value)
                break
        }
    }

    setInput = (option: any) => {
        this.setState({
            userInput   : option.label,
            value       : option.value
        })
    }

    onChange = (event:any) => {
        let newValue = event.target.value
        newValue = newValue.length > 0 ? newValue : null

        const res = stringToTimeOfDay(newValue)

        this.setState({
            userInput   : newValue,
            value       : res
        })
    }

    render() {
        return (
            <div className="gd-popover-search p-b-5">
                <input ref          = {this.refInput}
                       className    = "p-l-5"
                       placeholder  = {this.props.field.placeholder}
                       value        = {this.state.userInput}
                       onChange     = {this.onChange}
                       onKeyDown    = {this.onKeyDown} />
            </div>
        )
    }
}
